import PropTypes from "prop-types";
import colors from "constants/colors";

function IconLocation({ fill }) {
    return (
        <svg viewBox="0 0 40 40">
            <g fill={fill}>
                <path d="m21.5151515 0 .0007243 3.40162697c7.98458.72277035 14.3597269 7.09791723 15.0824972 15.08249723l3.401627.0007243v3.030303l-3.401627.0007243c-.7227703 7.98458-7.0979172 14.3597269-15.0824972 15.0824972l-.0007243 3.401627h-3.030303l-.0007243-3.401627c-7.98458-.7227703-14.35972688-7.0979172-15.08249723-15.0824972l-3.40162697-.0007243v-3.030303l3.40162697-.0007243c.72277035-7.98458 7.09791723-14.35972688 15.08249723-15.08249723l.0007243-3.40162697zm-1.5151515 6.36363636c-7.4747475 0-13.63636364 6.16161614-13.63636364 13.63636364s6.16161614 13.6363636 13.63636364 13.6363636 13.6363636-6.1616161 13.6363636-13.6363636-6.1616161-13.63636364-13.6363636-13.63636364zm0 6.76767674c3.8383838 0 6.8686869 3.0303031 6.8686869 6.8686869s-3.1313132 6.8686869-6.8686869 6.8686869-6.8686869-3.0303031-6.8686869-6.8686869 3.0303031-6.8686869 6.8686869-6.8686869z" />
            </g>
        </svg>
    );
}

IconLocation.propTypes = {
    fill: PropTypes.string
};

IconLocation.defaultProps = {
    fill: colors.darkNight
};

export default IconLocation;
